import {PropsWithChildren} from "react";

type Props = {
    id?: string,
    className?: string,
    style?: { [key: string]: string; },
    cellNum: number,
    hoverCell: number,
    setHoverCell: (n:number)=>any
    background?: string
    onClick?: ()=>any
    fadeDir?:string
}

const GridPanel = (props:PropsWithChildren<Props>) =>{
    return(
        <div data-aos-offset="-2000" data-aos={`${props.fadeDir}`}
            onClick={() => props.onClick ? props.onClick() : () => {
        }} style={{...props.style, zIndex: props.cellNum === props.hoverCell ? 3 : 2}}
             onMouseEnter={() => props.setHoverCell(props.cellNum)}
             onMouseLeave={() => props.setHoverCell(-1)}
             className={`relative touch-manipulation overflow-hidden rounded-xl border border-borderLight dark:border-borderDark
              bg-surfaceLight dark:bg-surfaceDark w-full shadow-sm transition-all duration-300
              hover:cursor-pointer hover:-translate-y-0.5 hover:border-accent
              hover:shadow-lg hover:shadow-slate-900/20
              active:cursor-pointer active:scale-[0.98] active:border-accent
              active:shadow-lg active:shadow-slate-900/20 ${props.className}`}>
            {props.background &&
                <div className="absolute inset-0">
                    <img alt="" className="h-full w-full object-cover object-center"
                         src={props.background}/>
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/55 to-slate-950/25"/>
                </div>}
            {props.children}
        </div>
    )
}

export default GridPanel
